import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Footer from '../components/layout/Footer';
import { getNotificationById } from '../services/api';

const BASE_API = process.env.REACT_APP_API_URL.replace(/\/api\/?$/, '');

const NewsDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    getNotificationById(id)
      .then((res) => {
        setArticle(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Lỗi khi lấy thông báo:', err);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div className="p-10 text-center text-gray-600">Đang tải thông báo...</div>;
  }

  if (!article) {
    return <div className="p-10 text-center text-red-500">Bài viết không tồn tại.</div>;
  }

  return (
    <div className="pt-16 bg-gray-50 min-h-screen flex flex-col">
      <div className="max-w-4xl mx-auto my-6 px-6 py-12 bg-white rounded-lg shadow-md mt-8">
        <button
          onClick={() => navigate(-1)}
          className="mb-6 text-blue-600 hover:text-blue-800 font-semibold"
        >
          &larr; Quay lại
        </button>

        <h1 className="text-4xl font-extrabold text-gray-900 mb-4">{article.title}</h1>

        <p className="text-gray-500 mb-6">
          {new Date(article.created_at).toLocaleDateString('vi-VN')} | {article.category || 'Thông báo'}
        </p>

        {article.thumbnail_url && (
          <div className="mb-6">
            <img
              src={`${BASE_API}/${(article.thumbnail_url || 'uploads/thumbnails/default.jpg').replace(/^\/+/, '')}`}

              alt="Thumbnail"
              className="w-full h-64 object-cover"
            />
          </div>
        )}

        <div className="text-lg text-gray-800 leading-relaxed whitespace-pre-line">
          {article.message}
        </div>

        {article.file_url && (
          <div className="mt-6">
            <a
              href={`${BASE_API}/${article.file_url.replace(/^\/+/, '')}`}
              {...(article.file_url.toLowerCase().endsWith('.pdf')
                ? { target: '_blank', rel: 'noopener noreferrer' }
                : { download: true })}
              className="inline-block bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700 transition"
            >
              📎 {article.file_url.toLowerCase().endsWith('.pdf') ? 'Xem tài liệu' : 'Tải xuống tài liệu'}
            </a>
          </div>
        )}

        {article.subnews && article.subnews.length > 0 && (
          <div className="mt-10">
            <h2 className="text-2xl font-semibold mb-4">Tin phụ</h2>
            <div className="space-y-6">
              {article.subnews.map((sub) => (
                <div key={sub.id} className="bg-gray-100 p-4 rounded-lg">
                  <h3 className="text-xl font-bold mb-2">{sub.title}</h3>
                  <p className="text-gray-700 whitespace-pre-line">{sub.message}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <Footer />
    </div>
  );
};

export default NewsDetail;
